<template>
 <iframe
    class="responsive-iframe"
    title="Análisis de Tocas"
    src="https://app.powerbi.com/view?r=eyJrIjoiOTY5ODlhYTAtZjg0MC00NWIzLWE5NWItMmI1MWNhYjk0MjlmIiwidCI6IjAxMTMwZjhlLTlhYWEtNDA0Yi1iZWJkLTM1YmE5ZTVkMWJmYiIsImMiOjR9"
    style="position:fixed; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"
    >
  </iframe>
</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
      }
    },
    mounted(){
    },
    methods:{

    }

  }
</script>

<style>
body {
  margin: 0;
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  padding-top: 1px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>